module.exports = __webpack_public_path__ + "static/media/2DGACM10.12b88010.jpg";